import React, {useEffect, useState} from 'react';
import queryString from "query-string";
import {useHistory} from "react-router-dom";
import {callApi} from "../../../connection/ClientApi";
import Urls from "../../../connection/Urls";
import messages from "res/messages/farsi";
import {IsF, IsLP_MP_SP, IsM, IsSM, IsT} from "my-styles/media/media";
import ProductDetailCard from "../product/ProductDetailCard";
import TitleProductList from "../dynamicLict/TitleProductList";
import {Helmet} from "react-helmet";

export default function Article(props) {
    const urlParams = queryString.parse(props.location.search);
    const history = useHistory();
    const [article, setArticle] = useState(undefined);

    useEffect(() => {
        if (urlParams.id) {
            requestGetArticle(urlParams.id);
        } else {
            props.onNavigate(history, "/")
        }
    }, [])

    const requestGetArticle = (articleId) => {
        let params = new FormData();
        params.append("article_id", articleId);
        callApi(Urls.getArticle, params, (data) => {
            if (data && data.description === 200 && data.result === "success") {
                setArticle(data.data);
            }
        }, () => {
            props.onAlert(messages.articleNotFound);
        }, () => {
            props.onLoading(true)
        }, () => {
            props.onLoading(false)
        })
    }


    return (
        <>
            <Helmet>
                <title>ØµØ±ÙÙ ÙØ§Ø±Ú©Øª - ÙÙØ§ÙØ§Øª</title>
                <meta property="og:image" content="%PUBLIC_URL%/favicon.ico"/>
                <meta property="og:url" content="https://sarfemarket.ir/"/>
                <meta name="google-site-verification" content="a7UDcP_j_QBlp1S7KGeczLTlvDmYkzvwyBo7Qa-qbH0"/>
            </Helmet>
            {article && (
                <div>
                    {IsSM() || IsM() ? (
                        <div>
                            <div className="container" style={{margin: '0 auto'}}>
                                <div style={{padding: '0.6rem'}}>
                                    <div className="card">
                                        <div className="flexContentCenter paddingTopSmall ">
                                            <h1 className="xxLargeTextBold">{article.title}</h1>
                                        </div>
                                        <div className="flexContentCenter marginTopMedium">
                                            <img src={article.image} style={{maxWidth:'100%'}} className="articleCoverImage "
                                                 alt=""/>

                                        </div>
                                        <div style={{padding: "0.5rem 1rem"}}>
                                            <p className={"paddingSmall largeText VScroll "}
                                            >
                                                <p className={"paddingSmall largeText "}
                                                   dangerouslySetInnerHTML={{__html: article.description}}></p>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                {
                                    article.products
                                    && article.products.map((product, index) => {
                                        return <ProductDetailCard key={index}
                                                                  product_id={product.product_id}  {...props}   />
                                    })
                                }

                            </div>
                            {article.related_products && article.related_products.length > 0 &&
                                (
                                    <div className="center marginSmall paddingSmall marginTopMedium"
                                         style={{marginTop: "1em", height: IsLP_MP_SP() ? 440 : 400}}>

                                        <TitleProductList
                                            {...props}
                                            products={article.related_products}
                                            header={{
                                                title: messages.relatedProducts
                                            }}
                                        />

                                    </div>
                                )
                            }

                        </div>
                    ) : article && IsF() ? (
                        <div>
                            <div className="container" style={{width: '90%', margin: '0 auto'}}>
                                <div className="flexContentCenter paddingTopSmall ">
                                    <h1 className="xxxLargeTextBold">{article.title}</h1>
                                </div>
                                <div className="flexContentCenter marginTopMedium">
                                    <img src={article.image} className="articleCoverImage "
                                         style={{width: '90%'}} alt=""/>
                                </div>

                                <p className={"paddingSmall largeText "}
                                   dangerouslySetInnerHTML={{__html: article.description}}></p>
                                {
                                    article.products
                                    && article.products.map((product, index) => {
                                        return <ProductDetailCard key={index}
                                                                  product_id={product.product_id}  {...props}   />
                                    })
                                }

                            </div>
                            {article.related_products && article.related_products.length > 0 &&
                                (
                                    <div className="center marginSmall paddingSmall marginTopMedium"
                                         style={{marginTop: "1em", height: IsLP_MP_SP() ? 440 : 400}}>
                                        <TitleProductList
                                            {...props}
                                            products={article.related_products}
                                            header={{
                                                title: messages.relatedProducts
                                            }}
                                        />
                                    </div>
                                )
                            }

                        </div>
                    ) : article && IsT() ? (
                        <div>
                            <div className="container" style={{width: '90%', margin: '0 auto'}}>
                                <div className="flexContentCenter paddingTopSmall ">
                                    <h1 className="xxxLargeTextBold">{article.title}</h1>
                                </div>
                                <div className="flexContentCenter marginTopMedium">
                                    <img src={article.image} className="articleCoverImage "
                                         style={{width: '90%'}} alt=""/>
                                </div>

                                <p className={"paddingSmall largeText "}
                                   dangerouslySetInnerHTML={{__html: article.description}}></p>
                                {
                                    article.products
                                    && article.products.map((product, index) => {
                                        return <ProductDetailCard key={index}
                                                                  product_id={product.product_id}  {...props}   />
                                    })
                                }

                            </div>
                            {article.related_products && article.related_products.length > 0 &&
                                (
                                    <div className="center marginSmall paddingSmall marginTopMedium"
                                         style={{marginTop: "1em", height: IsLP_MP_SP() ? 440 : 400}}>
                                        <TitleProductList
                                            {...props}
                                            products={article.related_products}
                                            header={{
                                                title: messages.relatedProducts
                                            }}
                                        />
                                    </div>
                                )
                            }

                        </div>
                    ) : (
                        <div>
                            <div className="container" style={{width: '90%', margin: '0 auto'}}>
                                <div className="flexContentCenter paddingTopSmall ">
                                    <h1 className="xxxLargeTextBold">{article.title}</h1>
                                </div>
                                <div className="flexContentCenter marginTopMedium">
                                    <img src={article.image} className="articleCoverImage "
                                         alt=""/>
                                </div>

                                <p className={"paddingSmall largeText "}
                                   dangerouslySetInnerHTML={{__html: article.description}}
                                   style={{fontFamily: 'FontAwesome'}}/>
                                {
                                    article.products
                                    && article.products.map((product, index) => {
                                        return <ProductDetailCard key={index}
                                                                  product_id={product.product_id}  {...props}   />
                                    })
                                }

                            </div>
                            {article.related_products && article.related_products.length > 0 &&
                                (
                                    <div className="center marginSmall paddingSmall marginTopMedium"
                                         style={{marginTop: "1em", height: IsLP_MP_SP() ? 440 : 400}}>
                                        <TitleProductList
                                            {...props}
                                            products={article.related_products}
                                            header={{
                                                title: messages.relatedProducts
                                            }}
                                        />
                                    </div>
                                )
                            }

                        </div>
                    )}
                </div>
            )}
        </>
    )
}